export default __webpack_public_path__ + "static/media/burglary2.9822fa0d.png";